module.exports = __webpack_public_path__ + "img/02.44e3d7de.jpg";